var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoutesMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7768 0.223178C16.0045 0.45086 16.0645 0.79709 15.9266 1.08808L9.06951 15.5642C8.93175 15.8551 8.62612 16.028 8.30587 15.9963C7.98563 15.9646 7.71985 15.7351 7.6418 15.4229L6.22886 9.77114L0.577133 8.3582C0.264933 8.28015 0.0354371 8.01437 0.00372691 7.69413C-0.0279833 7.37388 0.144931 7.06825 0.435762 6.93049L14.9119 0.0733641C15.2029 -0.0644757 15.5491 -0.00450381 15.7768 0.223178ZM3.01209 7.39624L7.04193 8.4037C7.31491 8.47195 7.52805 8.68509 7.5963 8.95807L8.60376 12.9879L13.6363 2.36373L3.01209 7.39624Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoutesMenu);
export default __webpack_public_path__ + "static/media/routesMenu.eb53b614.svg";
export { ForwardRef as ReactComponent };